

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxNavBar } from 'devextreme-vue';

@Component({
  components: {
    Datagrid,
    DxNavBar,
  },
})
export default class MachineryRentalsTable extends Vue {
    @Prop({required: false})
    private machineryId?: string;

    @Prop({required: false})
    private projectId?: string;

    @Prop({ required: false, default: false})
    public disabled!: boolean;

    private loading: boolean = false;
    private initialised: boolean = false;
    private onlyActiveContracts: boolean = false;

    public refresh() {
      try {
        ((this.$refs.rentalGrid as Datagrid).$refs.machineryRentalGrid as any).instance.refresh();
      } catch {
        notificationService.showErrorMessage('Mislukt om de grid te refreshen!');
      }
    }

    public mounted() {
        const onlyActiveFromStorage = localStorage.getItem('RentalContractShowOnlyActive');
        if (onlyActiveFromStorage && onlyActiveFromStorage.toLowerCase() === 'true') {
            this.onlyActiveContracts = true;
        }
        this.initialised = true;
    }

    private editRow(e: any) {
        if (this.disabled) {
            return;
        }

        if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
            this.$router.push({ path: `/machinery/${e.data.machineryId}/rentals/${e.data.id}` });
        }
    }

    private async deleteRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await machineryRentalsRepository.delete(e.data.id);
                notificationService.saved();
                setTimeout(() => {
                    self.refresh();
                }, 300);
                resolve(true);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    get rentalGridColumns() {
        const self = this;
        return [
            {
                dataField: 'documentNumber',
                caption: 'Documentnr.',
            },
            {
                dataField: 'machineryName',
                caption: 'Machine',
                allowFiltering: false,
                allowSorting: false,
                allowSearching: false,
            },
            {
                dataField: 'machineryProfile',
                caption: 'Profiel',
                allowFiltering: false,
                allowSorting: false,
                allowSearching: false,
            },
            {
                dataField: 'customerName',
                caption: 'Klant',
                allowFiltering: false,
                allowSorting: false,
                allowSearching: false,
            },
            {
                dataField: 'begin',
                caption: 'Begin',
                dataType: 'date',
            },
            {
                dataField: 'end',
                caption: 'Einde',
                dataType: 'date',
            },
            {
                dataField: 'unitPrice',
                caption: 'Prijs',
                format: CURRENCY_FORMAT,
                alignment: 'left',
            },
            {
                dataField: 'taxrate',
                caption: 'BTW %',
                dataType: 'number',
                alignment: 'left',
            },
            {
                dataField: 'prepayment',
                caption: 'Voorafbetaling',
                dataType: 'boolean',
            },
            {
                dataField: 'lastInvoicedDate',
                caption: 'Gefactureerd tot',
                dataType: 'date',
            },
            {
                dataField: 'nextInvoicedDate',
                caption: 'Volgende factuur datum',
                dataType: 'date',
            },
            {
                dataField: 'invoiced',
                caption: 'Gefactureerd',
                dataType: 'boolean',
            },
            {
                dataField: 'rentalMode',
                caption: 'Soort',
                lookup: {
                    items: [
                        { value: 0, text: 'Huren' },
                        { value: 1, text: 'Huurkoop' },
                    ],
                    valueExpr: 'value',
                    displayExpr: 'text',
                },
            },
            {
                type: 'buttons',
                buttons: ['edit', 'delete'],
            },
        ];
    }

    get datasource() {
        const self = this;
        return new DataSource({
            store: new dxCustomStore({
                key: 'id',
                load: async (loadOptions) => {
                    if (!self.onlyActiveContracts) {
                        self.onlyActiveContracts = false;
                    }
                    const result = await machineryRentalsRepository
                        .lookup(loadOptions, self.onlyActiveContracts, this.machineryId, this.projectId);
                    return result.data;
                },
            }),
            paginate: true,
        });
    }

    get toolbarOptions() {
        const self = this;

        return [
        {
            location: 'before',
            widget: 'dxCheckBox',
            options: {
                text: 'Enkel actieve contracten',
                width: 300,
                value: self.onlyActiveContracts,
                onValueChanged: (e: any) => {
                    if (e) {
                        self.onlyActiveContracts = e.value;
                        localStorage.setItem('RentalContractShowOnlyActive', e.value);
                        self.refresh();
                        return;
                    }
                },
            },
        },
        ];
    }

}
